import '@/assets/font/iconfont.css' // 引入字体图标
import '@/assets/font/iconfont.js' // 引入Symbol 模式字体图标
import '@/utils/naive-instance'
import 'element-plus/dist/index.css' // 或单独引入 less 入口
import 'normalize.css'
import 'virtual:uno.css'
import './styles/index.scss'
import './styles/rest.css'

// Vue核心及组件引入

const normalizeMockLoginUrl = () => {
  const { pathname, search, hash } = window.location
  if (pathname === '/mock-login' && search && !hash) {
    window.location.replace(`/#/mock-login${search}`)
    return true
  }
  return false
}

const isMockLoginUrlNormalized = normalizeMockLoginUrl()

import { TypeMappingPlugin } from '@/utils/exam-type'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 全局组件引入
const globalComponents = {
  Breadcrumb: () => import('@/components/common/Breadcrumb.vue'),
  CustomButton: () => import('./components/common/CustomButton.vue'),
  CustomHeader: () => import('./components/common/CustomHeaderTitle.vue'),
  CustomIcon: () => import('./components/common/CustomIcon.vue'),
  CustomTabs: () => import('./components/common/CustomTabs.vue'),
  BaseSkeleton: () => import('./components/global/BaseSkeleton/index.vue'),
  CustomLoading: () => import('./components/common/CustomLoading.vue')
}

// 图标注册
import icons from './global/register-icons'

if (!isMockLoginUrlNormalized) {
  // 创建并配置应用实例
  const app = createApp(App)
  app.use(TypeMappingPlugin)
  // 批量注册组件
  Object.entries(globalComponents).forEach(([name, component]) => {
    // 支持异步组件（优化首屏加载）
    app.component(name, component)
  })

  app.use(icons)
  app.use(store)
  app.use(router)
  app.mount('#app')
}
